import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { isEmpty } from "lodash";
export default {
  methods: {
    getChangelogName(userDetails) {
      const {
        givenName,
        familyName
      } = userDetails;
      return this.$auth.session.get().userDetails.username === userDetails.username ? this.$t("global.words.you") : `${givenName} ${familyName}`;
    },
    getChangelogOperation(operation, type = null) {
      const parser = {
        add: "added",
        update: "updated",
        remove: "removed"
      };
      if (type === "link-application") {
        return this.linkApplicationAction;
      }
      return this.$t("global.words")[parser[operation]];
    },
    getChangelogType(type) {
      const typei18nParser = {
        "common-field": "client-profile.changelog.type.common-field",
        "custom-field": "client-profile.changelog.type.custom-field",
        "co-applicants": "application-form.co-applicant",
        checklist: "global.words.checklist",
        note: "global.words.note",
        "follow-up": "global.words.activity",
        "board-status": "client-profile.changelog.type.board-status",
        ownership: "client-profile.changelog.typeownership",
        duplicate: "client-profile.changelog.duplicate"
      };
      return this.$tc(typei18nParser[type], 1);
    },
    parseValue({
      value,
      operation
    }) {
      const valueByOperationParser = {
        add: "to",
        remove: "from",
        update: "to"
      };
      return value[valueByOperationParser[operation]];
    },
    insertionTimestampTooltip(timestamp) {
      return this.$options.filters.formatDateHour(timestamp);
    },
    valueText(value) {
      return isEmpty(value) ? this.$t("global.words.empty") : value;
    },
    extractNameFromValue(value) {
      return `${value.givenName} ${value.familyName}`;
    },
    getChangelogSummaryMessage(type, origin = "boards") {
      const typeToUse = _includesInstanceProperty(type).call(type, "field") ? "field" : type;
      const messageParser = {
        active: `${origin}.changelog.markActiveInactiveMessage`,
        "board-status": `${origin}.changelog.changeStatusMessage`,
        checklist: `${origin}.changelog.changeMessage`,
        "co-applicants": `${origin}.changelog.changeMessage`,
        collaborator: `${origin}.changelog.changeEmailTracking`,
        field: `${origin}.changelog.changeMessage`,
        "follow-up": `${origin}.changelog.changeMessage`,
        "link-application": `${origin}.changelog.linkApplication`,
        note: `${origin}.changelog.changeMessage`,
        ownership: `${origin}.changelog.changeOwnershipMessage`,
        subscriber: `${origin}.changelog.changeNotifySubscribersMessage`,
        "track-emails": `${origin}.changelog.changeEmailTrackingIndividual`,
        duplicate: `${origin}.changelog.duplicate`,
        merge: `${origin}.changelog.merge`
      };
      return messageParser[typeToUse];
    },
    getClientProfileStatus(status) {
      return status ? this.$t("global.words.active") : this.$t("global.words.inactive");
    },
    changelogComponent(type) {
      const supportedComponents = ["co-applicants", "board-status", "checklist", "follow-up", "ownership", "note", "common-field", "custom-field", "collaborator", "subscriber", "link-application", "track-emails"];
      if (!_includesInstanceProperty(supportedComponents).call(supportedComponents, type)) return false;
      if (_includesInstanceProperty(type).call(type, "field")) return "changelog-field";
      return `changelog-${type}`;
    }
  },
  computed: {
    isUpdate() {
      return this.operation === "update";
    },
    isRemove() {
      return this.operation === "remove";
    },
    changeLogContainerClass() {
      return {
        "text-primary": this.isUpdate,
        "text-danger": this.isRemove
      };
    },
    isLinkApplication() {
      return isEmpty(this.value.from) && !isEmpty(this.value.to);
    },
    linkApplicationAction() {
      return this.isLinkApplication ? this.$t("global.words.linked") : this.$t("global.words.unlinked");
    }
  }
};